/* eslint-disable */
export function serviceServerName ({ mariadb, kubernetes_pod_name }) {
    if (mariadb && kubernetes_pod_name) return `${mariadb}/${kubernetes_pod_name}`
    if (mariadb && !kubernetes_pod_name) return mariadb
    return kubernetes_pod_name || mariadb
}
